import iview from 'iview'
import 'iview/dist/styles/iview.css';
import Vue from 'vue'
import router from './router'
import api from './config/api.js';
import PublicJs from './common/js/public.js';
import 'babel-polyfill';
import App from './App'
import store from "./store";
import VueDND from 'awe-dnd';
Vue.use(iview)
Vue.prototype.$api = api;
Vue.prototype.$bus = new Vue();
window.Message = Vue.$Message;
Vue.use(PublicJs)
Vue.config.productionTip = false;
Vue.use(VueDND)
Vue.directive('requiredNumber',{
    inserted: function (el) {
        el.addEventListener("keypress",function(e){
            e = e || window.event;
            let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
            let re = /\d/;
            
            if(charcode == 46){
                if(el.value.includes('.')){
                    e.preventDefault();
                }
                return;
            }else if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
                if(e.preventDefault){
                    e.preventDefault();
                }else{
                    e.returnValue = false;
                }
            }
            if((el.value.indexOf(".")!="-1") && el.value.substring(el.value.indexOf(".")).length>2){
                e.preventDefault();
                return
            }
        });
    }
})
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js